/** 
 * Helper method to wait for a middleware to execute before continuing
 * and to throw an error when an error happens in a middleware
 */
export default function initMiddleware(middleware) {
  return (req, res) =>
    new Promise((resolve, reject) => {
      middleware(req, res, (result) => {
        if (result instanceof Error) {
          return reject(result);
        }
        return resolve(result);
      });
    });
}
